var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "detection-management" },
    [
      _c("search", {
        attrs: { placeholder: "请输入姓名，支持模糊搜索" },
        on: { search: _vm.refreshList, clear: _vm.refreshList },
        model: {
          value: _vm.queryParams.patientName,
          callback: function ($$v) {
            _vm.$set(_vm.queryParams, "patientName", $$v)
          },
          expression: "queryParams.patientName",
        },
      }),
      _c(
        "pull-refresh",
        {
          attrs: { disabled: !_vm.pageInit },
          on: { refresh: _vm.refreshList },
          model: {
            value: _vm.pullLoading,
            callback: function ($$v) {
              _vm.pullLoading = $$v
            },
            expression: "pullLoading",
          },
        },
        [
          _vm.listInfo.length
            ? _c(
                "list",
                {
                  attrs: {
                    finished: !_vm.hasNext,
                    "finished-text": "没有更多了",
                    "immediate-check": false,
                  },
                  on: { load: _vm.loadList },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                [
                  _vm.listInfo.length == 0 && !_vm.loading
                    ? _c("div", {
                        staticStyle: {
                          "text-align": "center",
                          padding: "10vh 0",
                        },
                      })
                    : _vm._e(),
                  _vm._l(_vm.listInfo, function (item, index) {
                    return _c("reportIBox", {
                      key: index,
                      attrs: { info: item },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
          !_vm.listInfo.length
            ? _c("empty", { attrs: { description: "暂无数据" } })
            : _vm._e(),
          _c("div", { staticStyle: { height: "60px" } }),
        ],
        1
      ),
      _c("tabbar", { attrs: { curIndex: 1 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }